module.exports = __webpack_public_path__ + "static/img/FORD.bd41fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/FORD.png
// module id = zvwn
// module chunks = 1